import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllContents: build.mutation({
            // query: () => `/caterer/get/all/public`,
            query: (body) => ({
                url: `/content/editor`,
                // url: "http://localhost:5055/api/content/editor/",
                method: "POST",
                body
            })

        }),

    }),
    overrideExisting: false,
})

export const { useGetAllContentsMutation } = extendedApi